import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import config from '../../config';
import axios from 'axios';

import '../../css/SingleScreens/ConsultationScreen.css';

import { Routes as routes } from '../../navigation';
import { UserActions, NavigationActions, ContextActions, PracticeActions } from '../../actions';
import { SwitchAccount, TitleBar, NavBar, SingleScreenNavBar } from  '../../components'

class PracticeAlertAddEditScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {
      alert: '',
    }
  }

  componentDidMount() {
    const props = this.props.location.state.props;
    if (props && props.alert) {
      const existingAlert = props.alert;
      const message = existingAlert.message || '';
      this.setState({ ...this.state, alert: message });
    }
  }

  getSectionInfo = (alreadyExsits, props) => {
    const alertType = props.alertType;

    var sectionTitle    = '';
    var sectionSubtitle = '';
    var alertObject     = {};

    switch (alertType) {
      case 'initial':
        sectionTitle = alreadyExsits ? 'Edit Initial Message' : 'Add an Initial Message';
        sectionSubtitle = 'A Client will see this when they Start a Consultation';
        alertObject = {
          practice_id: props.practice_id,
          practice_location_id: props.location_id,
          message: this.state.alert,
          type: 'INITIAL',
        }
        break;
      case 'welcome':
        sectionTitle = alreadyExsits ? 'Edit Welcome Message' : 'Add a Welcome Message';
        sectionSubtitle = 'A Client will see this after they complete the Start a Consultation form';
        alertObject = {
          practice_id: props.practice_id,
          provider_id: props.user_id,
          message: this.state.alert,
          type: 'WELCOME',
        }
        break;
      default:

    }
    return {
      title: sectionTitle,
      subtitle: sectionSubtitle,
      alertObject: alertObject,
    }
  }

  renderAddEditInitialMessage = (props) => {
    const alreadyExsits = props.alert ? true : false;
    const sectionInfo   = this.getSectionInfo(alreadyExsits, props);
    return <div className="flex-container screen-main-content">
      <div className="screen-container-column">
        <div className="basic-container flex-container-column">
          <h5>{ sectionInfo.title }</h5>
          <span style={{ fontSize: 14, color: 'grey', marginTop: -10 }}>{ sectionInfo.subtitle }</span>

          <textarea
              placeholder="Enter Message..."
              rows="3"
              type="text"
              name="message"
              className="consultations-message-input"
              style={{ margin: 0, marginTop: 20 }}
              value={this.state.alert}
              onChange={(event) => { this.setState({ ...this.state, alert: event.target.value  }) }}
            >
            </textarea>

            <div className='flex-container-row flex-center-justify' style={{ marginTop: 20 }}>
              <input  type="submit"
                      value="Cancel"
                      style={{ marginRight: 5 }}
                      className="button-clear"
                      onClick={ () => {
                        NavigationActions.navigateBack();
                      }}
                    />
              <input  type="submit"
                      value='Save'
                      className="button-default"
                      style={{ marginRight: 5 }}
                      onClick={ () => {
                        const alert = sectionInfo.alertObject;
                        const token = this.props.user.auth.token || '';
                        if (alreadyExsits) {
                          var editedAlert = Object.assign({}, props.alert);
                          editedAlert.message = this.state.alert;
                          this.props.practiceActions.editAlert(token, editedAlert, this.successAction);
                        } else {
                          this.props.practiceActions.addAlert(token, alert, this.successAction);
                        }
                      }}
                    />
            </div>

        </div>
      </div>
    </div>
  }

  renderAlertAddEdit = () => {
    const props = this.props.location.state.props;
    return this.renderAddEditInitialMessage(props);
  }

  render() {

    return (
      <div className="flex-container flex-container-column flex-center-align">
        <TitleBar
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          practices={this.props.user.practices}
          practice={this.props.practice.practice}
          userActions={this.props.userActions}
        />
        <SingleScreenNavBar title="Practice Initial Message" />
        { this.renderAlertAddEdit() }
      </div>
    );
  }

  successAction = () => {
    NavigationActions.navigateBack();
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    context: state.context,
    practice: state.practice,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    contextActions: bindActionCreators(
     { ...ContextActions }, dispatch),
    practiceActions: bindActionCreators(
     { ...PracticeActions }, dispatch),
    userActions: bindActionCreators(
     { ...UserActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PracticeAlertAddEditScreen)
